import React, { useEffect, useState } from "react";

import AppliedClassesStudentCardComponent from "./AppliedClassesStudentCardComponent";
import axios from "../../../axios";
import "./AppliedClassesComponent.css";

export default function AppliedClassesComponent() {
  const [tutorAppliedJobCards, setTutorAppliedJobCardsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("/v1/tutor/applied-classes")
      .then((res) => {
        if (res.data.is_success && res.data.data) {
          setTutorAppliedJobCardsData(res.data.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error fetching bank details", err);
        setLoading(true);
      });
  }, []);

  if (!tutorAppliedJobCards || loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <div className="loading">
          <img src="./book-loader.gif" alt=" Loading . . .  " />
        </div>
      </div>
    );
  }

  return (
    <div className="personal-info--container">
      <div className="normal-cards-container">
        {tutorAppliedJobCards.map((appliedJobCard, indx) => (
          <div className="student-card" key={`normal-${indx}`}>
            <AppliedClassesStudentCardComponent cardDetails={appliedJobCard} />
          </div>
        ))}
      </div>
    </div>
  );
}
